import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Partner } from "@/features/partners/models/partner";

const baseURL = import.meta.env.VITE_SERVER_API_URL;

function PartnerDiscountDialog({
	showPartnerDiscountsModal,
	setShowPartnerDiscountsModal,
	selectedPartner,
}: {
	selectedPartner?: Partner | undefined;
	showPartnerDiscountsModal: boolean;
	setShowPartnerDiscountsModal?: (open: boolean) => void;
}) {
	return (
		<Dialog
			open={showPartnerDiscountsModal}
			onOpenChange={setShowPartnerDiscountsModal}
		>
			<DialogContent className="max-h-[80vh] overflow-auto">
				<div className="flex flex-col gap-6 md:flex-row md:gap-8">
					<img
						src={`${baseURL}/common/image/${selectedPartner?.logoUrl}`}
						className="max-sm:bg-light h-30 w-30 object-contain max-sm:mt-2 max-sm:w-full max-sm:rounded-[24px] max-sm:px-8 max-sm:py-12"
					/>

					<div className="flex flex-col gap-4 md:gap-8">
						<p className="web-heading-h3 break-all whitespace-normal">
							{selectedPartner?.name}
						</p>

						<div className="flex flex-col gap-3 md:gap-4">
							<div className="flex flex-col justify-between md:flex-row">
								<p className="web-body-b1-medium">Membership discount: </p>
								<p className="web-body-b1 break-all whitespace-normal md:text-right">
									{selectedPartner?.discount}
								</p>
							</div>

							<div className="flex flex-col justify-between md:flex-row">
								<p className="web-body-b1-medium">Access it here: </p>
								<p className="web-body-b1 break-all whitespace-normal md:text-right">
									<a
										href={selectedPartner?.url}
										target="_blank"
										rel="noopener noreferrer"
										className="break-all"
									>
										{selectedPartner?.url}
									</a>
								</p>
							</div>

							{selectedPartner?.couponCode && (
								<div className="flex flex-col justify-between md:flex-row">
									<p className="web-body-b1-medium">Coupon:</p>
									<p className="web-body-b1 break-all whitespace-normal md:text-right">
										{selectedPartner?.couponCode}
									</p>
								</div>
							)}
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}

export default PartnerDiscountDialog;
